// Copyright (c) 2017 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../../../../shared/services/available-excel-columns';
import ExcelLayoutModal from '../../../../shared/components/excel-layout/excel-layout-modal';
import ExportToExcel from '../../../../shared/state/export-to-excel';
import OpenPipsFacetsModel from '../../state/facets';
import OpenPipsHeader from './open-pips-header';
import OpenPipsSearchBox from './open-pips-search-box';
import PipProduct from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import PipsProductsList from '../../../shared/components/pips-results-container';
import RefinableListWidgetWithExportAndLayouts from '../../../../shared/components/refinable-list-widget/refinable-list-widget-with-export-and-layouts';
import SearchFilters from '../../../../shared/state/search-filters';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import State from '../../state';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {getPipProductColumns} from '../../../shared/services/pip-product-excel-columns';
import {getSortByList} from '../../../../shared/services/get-excel-layout-modal-sort-by-list';
import {hasAccess} from '../../../../shared/services/security';
import openPipsSortOptions from '../../../shared/constants/pip-products-sort-options';

function handleCreateExcelLayout() {

    const availableColumns = getAllAvailableColumns('pipProducts');

    this.actions.updateExcelLayoutModalExcelLayout(true);
    this.actions.updateExcelLayoutModalIsNewLayout(true, 'pipProducts');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

    if (!this.exportToExcel.excelLayouts.pipProducts.length) {

        this.actions.updateExcelLayoutModalExcelLayoutIsDefault(true);

    }

    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleEditExcelLayout() {

    const availableColumns = getAvailableColumns('pipProducts', this.exportToExcel.selectedExcelLayout.pipProducts.columns);

    this.actions.updateExcelLayoutModalExcelLayout(false, this.exportToExcel.selectedExcelLayout.pipProducts);
    this.actions.updateExcelLayoutModalIsNewLayout(false, 'pipProducts');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);
    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleExcelLayoutChange(selectedLayout) {

    const availableColumns = getAvailableColumns('pipProducts', selectedLayout.columns);

    this.actions.updateSelectedExcelLayout(selectedLayout, 'pipProducts');
    this.actions.updateExcelLayoutModalExcelLayout(false, selectedLayout);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

}

function handleExportToExcel(language) {

    this.actions.exportToExcel(this.facets, language, 'pipProducts', this.exportToExcel.selectedExcelLayout.pipProducts.name);

}

function handleColumnMove(dragIndex, hoverIndex, listId, dragCard) {

    listId === 'available-items' ?
        this.actions.updateExcelLayoutModalAvailableColumnsOrder(dragIndex, hoverIndex, dragCard) :
        this.actions.updateExcelLayoutModalExcelLayoutColumnsOrder(dragIndex, hoverIndex, dragCard);

}

function handleColumnPush(column, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.pushExcelLayoutModalExcelLayoutColumn(column) :
        this.actions.pushExcelLayoutModalAvailableColumn(column);

}

function handleColumnRemove(index, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.removeExcelLayoutModalAvailableColumn(index) :
        this.actions.removeExcelLayoutModalExcelLayoutColumn(index);

}

function handleExcelLayoutDelete() {

    this.actions.deleteExcelLayout(this.exportToExcel.selectedExcelLayout.pipProducts.name, this.exportToExcel.selectedExcelLayout.pipProducts.listId, 'pipProducts');

}

function handleLayoutNameBlur(layoutName) {

    const nameAlreadyExists = this.exportToExcel.excelLayouts.pipProducts.some(layout => layout.name === layoutName);

    nameAlreadyExists ?
        this.actions.updateExcelLayoutModalIsNameValid(false) :
        this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleLayoutNameChange(layoutName) {

    this.actions.updateExcelLayoutModalLayoutName(layoutName);

}

function handleExcelLayoutModalClose() {

    this.actions.updateExcelLayoutModalVisibility(false);
    this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleSaveExcelLayout() {

    this.actions.saveExcelLayout(this.exportToExcel.excelLayoutModal.excelLayout, 'pipProducts');

}

function handleSetAsDefaultChange(isSelected) {

    this.actions.updateExcelLayoutModalExcelLayoutIsDefault(isSelected);

}

function handleSortByChange(sortByColumn) {

    this.actions.updateExcelLayoutModalExcelLayoutSortBy(sortByColumn, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateExcelLayoutModalExcelLayoutSortDirection(sortDirection, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

class OpenPipsMain extends Component {

    componentWillMount() {

        this.props.actions.readOpenPipsData(this.props.facets);

        if (hasAccess(this.props.security, 'PIP', 'PIP_LABOR_ADD_SUMM')) {

            this.props.actions.readLaborAdditivePipsData();

        }

    }

    componentWillUnmount() {

        this.props.actions.resetExportToExcelLayout();

    }

    render() {

        return (
            <main className='open-pips-results-main'>
                <OpenPipsSearchBox/>
                <OpenPipsHeader
                    hasSearchResults={this.props.hasSearchResults}
                    laborAdditivePipProductsCount={this.props.laborAdditivePipProductsCount}
                    pipProductsCount={this.props.pipProductsCount}
                    searchResultsCount={this.props.searchResultsCount}
                    security={this.props.security}
                />
                <section className='open-pips-results-container'>
                    <RefinableListWidgetWithExportAndLayouts
                        excelLayouts={this.props.exportToExcel.excelLayouts.pipProducts}
                        hasResults={this.props.pipProductsCount > 0}
                        onCreateLayout={this.props::handleCreateExcelLayout}
                        onEditLayout={this.props::handleEditExcelLayout}
                        onExport={handleExportToExcel.bind(this.props, this.context.user.getLocale())}
                        onFilterByChange={this.props.actions.updateListFilterBy}
                        onLayoutChange={this.props::handleExcelLayoutChange}
                        onSortByChange={this.props.actions.updateListSortBy}
                        onSortDirectionChange={this.props.actions.updateListSortDirection}
                        searchFilters={this.props.searchFilters}
                        selectedLayout={this.props.exportToExcel.selectedExcelLayout.pipProducts}
                        sortOptions={openPipsSortOptions}
                        type={State}
                    />
                    <PipsProductsList
                        busyCounter={this.props.busyCounter}
                        pipProducts={this.props.pipProductsFiltered}
                    />
                </section>
                <ExcelLayoutModal
                    excelLayoutModal={this.props.exportToExcel.excelLayoutModal}
                    mappingTable={getPipProductColumns().listColumns}
                    onColumnMove={this.props::handleColumnMove}
                    onColumnPush={this.props::handleColumnPush}
                    onColumnRemove={this.props::handleColumnRemove}
                    onLayoutDelete={this.props::handleExcelLayoutDelete}
                    onLayoutNameBlur={this.props::handleLayoutNameBlur}
                    onLayoutNameChange={this.props::handleLayoutNameChange}
                    onModalClose={this.props::handleExcelLayoutModalClose}
                    onSaveLayout={this.props::handleSaveExcelLayout}
                    onSetAsDefaultChange={this.props::handleSetAsDefaultChange}
                    onSortByChange={this.props::handleSortByChange}
                    onSortDirectionChange={this.props::handleSortDirectionChange}
                    sortByList={getSortByList(getPipProductColumns().listColumns, this.props.exportToExcel.excelLayoutModal.excelLayout.columns)}
                />
            </main>
        );

    }

}

OpenPipsMain.displayName = 'OpenPips';
OpenPipsMain.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    facets: PropTypes.instanceOf(OpenPipsFacetsModel).isRequired,
    hasSearchResults: PropTypes.bool.isRequired,
    laborAdditivePipProductsCount: PropTypes.number.isRequired,
    pipProductsCount: PropTypes.number.isRequired,
    pipProductsFiltered: PropTypes.arrayOf(PropTypes.instanceOf(PipProduct)).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchResultsCount: PropTypes.number.isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};
OpenPipsMain.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default OpenPipsMain;



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/open-pips-main/open-pips-main.js